import { useEffect, useState } from 'react';
import api from '../../../api/api';
import { handleRequestHelper } from '../../../utils/helpers';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';
import { NOTIFICATION_VARIANT } from '../../../constants/types';

export const useArtistManagementPage = (eventId) => {
  const [event, setEvent] = useState(null);
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotifications();

  const fetchEvent = async () => {
    await handleRequestHelper({
      endpoint: () => api.getEvent(eventId),
      onSuccess: ({ event }) => {
        setEvent(event);
      },
      showNotification,
    });
  };

  const searchArtist = async (searchQuery) => {
    return handleRequestHelper({
      endpoint: () => api.searchArtist(searchQuery),
      onSuccess: ({ artists }) => artists,
    });
  };

  const fetchArtists = async () => {
    setLoading(true);
    await handleRequestHelper({
      endpoint: () => api.getArtistsByEvent(eventId),
      onSuccess: ({ artists }) => {
        setArtists(artists);
        setLoading(false);
      },
      onFailure: () => {
        setLoading(false);
        showNotification('Hubo un error al eliminar el artista', NOTIFICATION_VARIANT.ERROR);
      },
      showNotification,
    });
  };

  const removeArtist = async (artistId) => {
    await handleRequestHelper({
      endpoint: () => api.removeArtistFromEvent(artistId, eventId),
      onSuccess: () => {
        setArtists((prev) => prev.filter((a) => a.id !== artistId));
        showNotification('Artista eliminado correctamente', NOTIFICATION_VARIANT.SUCCESS);
      },
      onError: () => {
        showNotification('Hubo un error al eliminar el artista', NOTIFICATION_VARIANT.ERROR);
      },
      showNotification,
    });
  };

  const addArtist = async (artist) => {
    if (!artist) return;
    const { label, ...newArtist } = artist;
    await handleRequestHelper({
      endpoint: () => api.addArtistToEvent({ artist: newArtist }, eventId),
      onSuccess: async () => {
        await fetchArtists();
        showNotification('Artista agregado correctamente', NOTIFICATION_VARIANT.SUCCESS);
      },
      onError: () => {
        showNotification('No se pudo agregar el artista.', NOTIFICATION_VARIANT.ERROR);
      },
      showNotification,
    });
  };

  useEffect(() => {
    fetchEvent();
    fetchArtists();
  }, []);

  return { event, artists, loading, searchArtist, removeArtist, addArtist };
};
